import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "../../config";

function useGetShippingCostsList(params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/shipping/shipping-costs`, { params });
            return res.data;
        },
        queryKey: ['shipping-costs-list', params?.page, params?.limit, params?.item_mlb, params?.user_id, params?.list_cost_min, params?.list_cost_max, params?.createdAt_start, params?.createdAt_end],
        enabled: enabled,
        retry: false,
        refetchOnWindowFocus: false
    });
}

function useCheckShippingCostsExportStatus() {
    return useMutation({
        mutationFn: async ({ jobId }) => {
            const res = await api.get(`/shipping/shipping-costs/export/status/${jobId}`);
            return res.data;
        }
    });
}

export {
    useGetShippingCostsList,
    useCheckShippingCostsExportStatus
};